import React, { useState, lazy, Suspense } from "react";
import { Tabs, Tab } from "react-bootstrap";

// Custom Loader Component
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const PropertyConfiguration = () => {
  const [activeTab, setActiveTab] = useState("Customers");

  // Lazoffersy load components
  const DigitalMenu = lazy(() => import("./components/DigitalMenuConfig"));
  const Website = lazy(() => import("./marketing/Website"));
  const Offers = lazy(() => import("./marketing/Offers"));
  const Reviews = lazy(() => import("./marketing/ReviewDashboard"));


  return (
    <div className="page-wrapper posmt-3">
      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-6 float-end ms-auto">
              <div className="d-flex justify-content-end">
                {/* Add any buttons here if needed */}
              </div>
            </div>
          </div>
        </div>
        <div className="profile-bg-">
          <Tabs
            id="property-config-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-4"
          >
            <Tab eventKey="Customers" title={<><i className="fas fa-users me-2"></i> Customers</>}>
              <div className="card">
                <div className="card-body">
                  <h4>Customers</h4>
                  <p>Placeholder content for Customers tab. Add your content or component here.</p>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Campaign" title={<><i className="fas fa-bullhorn me-2"></i> Campaign</>}>
              <div className="card">
                <div className="card-body">
                  <h4>Campaign</h4>
                  <p>Placeholder content for Campaign tab. Add your content or component here.</p>
                </div>
              </div>
            </Tab>
            <Tab eventKey="DigitalMenu" title={<><i className="fas fa-book me-2"></i> Digital Menu</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "DigitalMenu" && <DigitalMenu />}
                </Suspense>
              </div>
            </Tab>
            <Tab eventKey="Website" title={<><i className="fas fa-globe me-2"></i> Website</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "Website" && <Website />}
                </Suspense>
              </div>
            </Tab>
         <Tab eventKey="Offers" title={<><i className="fas fa-globe me-2"></i> Offers</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "Offers" && <Offers />}
                </Suspense>
              </div>
            </Tab>


            <Tab eventKey="Reviews" title={<><i className="fas fa-star me-2"></i> Reviews</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "Reviews" && <Reviews />}
                </Suspense>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default PropertyConfiguration;